/**
 * Subscribe/notify plus a `stable` snapshot cache for `useSyncExternalStore`.
 * Usage and rules: client/docs/EXTERNAL-STORES.md
 */
export const createExternalStore = <T>() => {
  const listeners = new Set<() => void>();
  const cache = new Map<string, { serialized: string; value: T }>();

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const notify = () => listeners.forEach((listener) => listener());

  const stable = (value: T, slot = ''): T => {
    const serialized = JSON.stringify(value ?? null);
    const hit = cache.get(slot);

    if (hit?.serialized === serialized) return hit.value;

    cache.set(slot, { serialized, value });
    return value;
  };

  return { notify, stable, subscribe };
};
